import { render } from "./IFrameWarningToast.vue?vue&type=template&id=022f72cb&scoped=true"
import script from "./IFrameWarningToast.vue?vue&type=script&lang=js"
export * from "./IFrameWarningToast.vue?vue&type=script&lang=js"

import "./IFrameWarningToast.vue?vue&type=style&index=0&id=022f72cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022f72cb"]])

export default __exports__